export default {
    STEP_ITEM: 1,
    STEP_ADJUSTMENT: 2,
    STEP_PAYMENT: 3,
    /* STEP_CONFIRMATION: 4,*/
    STEP_SUCCESS: 4,

    PAYMENT_CONFIRM_STEP_NONE: 0,
    PAYMENT_CONFIRM_STEP_REMAINING: 1,
    PAYMENT_CONFIRM_STEP_CONFIRMATION: 2,
    PAYMENT_CONFIRM_STEP_PROCESS_PAYMENT: 3,

    ADJUSTMENT_SHIPPING_KEY: 'adjustment_shipping_value',
    ADJUSTMENT_POSITIVE_KEY: 'adjustment_positive_value',
    ADJUSTMENT_NEGATIVE_KEY: 'adjustment_negative_value',
}



// WEBPACK FOOTER //
// ./src/view/constant/order/creditmemo/CreateCreditmemoConstant.js